<ng-container [ngSwitch]="col.type">
	<div
		[ngStyle]="{
			'text-align': col?.numberType === 'currency' ? 'right' : col.textAlign,
		}"
		[ngClass]="{
			'c-pointer': col.showTooltip,
		}"
		tooltipPosition="top"
		[pTooltip]="col.showTooltip ? value : ''">
		<ng-container *ngSwitchDefault>
			<ng-container [ngSwitch]="col.case">
				<ng-container *ngSwitchCase="'upperCase'">
					{{ value | uppercase }}
				</ng-container>
				<ng-container *ngSwitchCase="'lowerCase'">
					{{ value | lowercase }}
				</ng-container>
				<ng-container *ngSwitchDefault>
					<ng-container *ngIf="!col.translate; else translate">
						{{ value }}
					</ng-container>
				</ng-container>
			</ng-container>
		</ng-container>

		<ng-container *ngSwitchCase="'date'">
			{{ value | date: col.dateFormat }}
		</ng-container>

		<ng-container *ngSwitchCase="'number'">
			@if (col.numberType === 'percent') {
				<!-- NOTE: percent pipe'ı değeri 100 ile çarptığı için değer 100'e bölünmüştür. -->
				{{ (value ?? 0) / 100 | percent: col.numberFormat }}
			} @else if (col.numberType === 'currency') {
				{{ value ?? 0 | smartyCurrency: col.numberFormat : rowData[col?.currencyField] }}
			} @else {
				{{ value ?? 0 | number: col.numberFormat }}
			}
		</ng-container>

		<ng-container *ngSwitchCase="'status'">
			<span class="circle" [ngClass]="value | lowercase"></span>
			<ng-container *ngIf="!col.translate; else translate">
				{{ value }}
			</ng-container>
		</ng-container>

		<ng-container *ngSwitchCase="'valid'">
			{{ 'table.valid.' + value | translate }}
		</ng-container>

		<ng-container *ngSwitchCase="'render'">
			{{ rowData | render: col.renderMethod }}
		</ng-container>

		<ng-container *ngSwitchCase="'boolean'">
			{{ 'table.bool.' + value | translate }}
		</ng-container>
	</div>
</ng-container>

<ng-template #translate>
	{{
		value
			? ((col.prefix ? col.prefix + '.' + value.toString().toLowerCase() : value.toString().toLowerCase()) | translate)
			: ''
	}}
</ng-template>
